import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ec358d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["min", "max", "step", "value"]
const _hoisted_2 = ["min", "max", "step", "value"]
const _hoisted_3 = {
  key: 0,
  class: "slider-values"
}

import { PropType, computed, onMounted, ref } from "vue";

// define component props for the slider component
type MoveDataType = {
  value: number | string;
  percent: number | string;
  difference?: number | string;
};
/**
 * События
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmSlider',
  props: {
  /**
   * Минимальное значение для слайдера
   */
  min: {
    type: Number as PropType<number>,
    default: 0,
  },
  /**
   * Максимальное значение для слайдера
   */
  max: {
    type: Number as PropType<number>,
    default: 100,
  },
  /**
   * Размер шага значение для слайдера
   */
  step: {
    type: Number as PropType<number>,
    default: 1,
  },
  /**
   * Двойной ли слайдер
   */
  isDouble: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Показывать ли линейку
   */
  isShowRangeLine: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Маленький ли размер
   */
  isSmall: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Разбег минимальной границы
   */
  stepToMove: {
    type: Number as PropType<number>,
    default: 1,
  },
  /**
   * Разбег минимальной границы. Значение которое устанавливается для инпута
   */
  minValue: {
    type: Number as PropType<number>,
    default: 0,
  },
  /**
   * Разбег Максимальной границы. Значение которое устанавливается для инпута
   */
  maxValue: {
    type: Number as PropType<number>,
    default: 100,
  },
},
  emits: ["minValue", "maxValue"],
  setup(__props, { emit }) {

const props = __props;


/**
 * Тип для передаваемых данных
 */

/**
 * Элементы
 */
const minInput = ref<HTMLInputElement>(null);
const maxInput = ref<HTMLInputElement>(null);
const sliderTrack = ref<HTMLInputElement>(null);
/**
 * Заполнение лейблов для значений
 */
const computedLabelsNumList = computed(() => {
  let calcLebels = [];
  calcLebels[0] = props.min;
  calcLebels[1] = Math.floor((props.max - props.min) / 2);
  calcLebels[2] = props.max;
  console.log(calcLebels);
  return calcLebels;
});

onMounted(() => {
  calculateSliderOneMin();
  calculateSliderTwoMax();
  if (!props.isDouble) {
    console.log(maxInput.value.classList);
    minInput.value.classList.add("slider-input--hide");
  }
});

/**
 * Срабатывает при событии инпута в шаблоне.
 * Просчитывает ширину заполнителя и отправляет событие
 */
const calculateSliderOneMin = () => {
  if (Number(maxInput.value.value) - Number(minInput.value.value) <= props.stepToMove) {
    minInput.value.value = (Number(maxInput.value.value) - props.stepToMove).toString();
  }
  computedFillColor();
  emit("minValue", {
    value: minInput.value.value,
    percent: ((Number(minInput.value.value) - props.min) / (props.max - props.min)) * 100,
    ...(props.isDouble && {
      difference: Number(maxInput.value.value) - Number(minInput.value.value),
    }),
  });
};
/**
 * Срабатывает при событии инпута в шаблоне.
 * Просчитывает ширину заполнителя и отправляет событие
 */
const calculateSliderTwoMax = () => {
  if (Number(maxInput.value.value) - Number(minInput.value.value) <= props.stepToMove) {
    maxInput.value.value = (Number(minInput.value.value) + props.stepToMove).toString();
  }
  computedFillColor();
  emit("maxValue", {
    value: maxInput.value.value,
    percent: ((Number(maxInput.value.value) - props.min) / (props.max - props.min)) * 100,
    ...(props.isDouble && {
      difference: Number(maxInput.value.value) - Number(minInput.value.value),
    }),
  });
};
/**
 *
 * Просчитывает ширину заполнителя
 */
const computedFillColor = () => {
  let percentMin = ((Number(minInput.value.value) - props.min) / (props.max - props.min)) * 100;
  let percentMax = ((Number(maxInput.value.value) - props.min) / (props.max - props.min)) * 100;
  if (props.isDouble) {
    sliderTrack.value.style.background = `linear-gradient(to right, var(--neutral-10) ${percentMin}% , var(--accent) ${percentMin}% , var(--accent) ${percentMax}%, var(--neutral-10) ${percentMax}%)`;
  } else {
    sliderTrack.value.style.background = `linear-gradient(to right,  var(--accent) ${percentMax}%, var(--neutral-10) ${percentMax}%)`;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["slider", {
      'slider--small': !props.isShowRangeLine,
    }])
  }, [
    _createElementVNode("div", {
      ref_key: "sliderTrack",
      ref: sliderTrack,
      class: _normalizeClass(["slider-track", {
        'slider-track--small': props.isSmall,
      }])
    }, [
      _createElementVNode("input", {
        type: "range",
        class: "slider-input",
        ref_key: "minInput",
        ref: minInput,
        min: props.min,
        onInput: calculateSliderOneMin,
        max: props.max,
        step: props.step,
        value: props.minValue
      }, null, 40, _hoisted_1),
      _createElementVNode("input", {
        type: "range",
        class: "slider-input",
        ref_key: "maxInput",
        ref: maxInput,
        min: props.min,
        onInput: calculateSliderTwoMax,
        max: props.max,
        step: props.step,
        value: props.maxValue
      }, null, 40, _hoisted_2)
    ], 2),
    (__props.isShowRangeLine)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedLabelsNumList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "slider-values__num",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})